import {ref} from 'vue';
import {defineStore} from 'pinia';
import {useRouter} from "vue-router";
import axios from "axios";
import Network from "@/common/network";

export const useSessionStore = defineStore('session', () => {

    const router = useRouter();

    const authorized = ref(false);
    const profile = ref();

    const login = async ({account, password}) => {
        const response = await axios.post('/api/auth/login', {
            account,
            password,
        });

        if (response.status !== 200)
            return [Network.unknownError.message, response];

        const apiResponse = response.data;
        if (Network.unauthorized.code === apiResponse.code)
            return [Network.unauthorized.message, apiResponse];

        else if (Network.noError.code !== apiResponse.code)
            return [Network.unknownError.message, apiResponse];

        return [, apiResponse];
    };

    const loginUser = async ({name, password}) => {
        const userResponse = await axios.post(`/api/user/find`, {
            name,
            password,
        });

        if (userResponse.status !== 200)
            return [Network.unknownError.message, userResponse];

        const userResponseData = userResponse.data;
        if (Network.unauthorized.code === userResponseData.code)
            return [Network.unauthorized.message, userResponseData];

        else if (Network.noError.code !== userResponseData.code)
            return [Network.unknownError.message, userResponseData];

        const account = userResponseData.response.account;
        return login({account, password});
    };

    const logout = async () => {
        if (authorized.value) {
            authorized.value = false;
            await axios.get('/api/auth/logout');
        }
        
        await router.push({name: 'login'});
        profile.value = null;
    };

    const changePassword = async ({account, password, newPassword}) => {
        const response = await axios.put('/api/auth/changePassword', {
            account: account || profile.value.account,
            password,
            newPassword,
        });

        if (response.status !== 200)
            return [Network.unknownError.message, response];

        const apiResponse = response.data;
        if (Network.unauthorized.code === apiResponse.code)
            return [Network.unauthorized.message, apiResponse];

        else if (Network.noError.code !== apiResponse.code)
            return [Network.unknownError.message, apiResponse];

        return [, apiResponse];
    };

    return {authorized, profile, login, loginUser, logout, changePassword};
});
